import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_N_ACCOUNT = '/spe-n-account';
let SpeNAccountProxy = class SpeNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getUserBankInfo(uuid) {
        const uri = `${SPE_N_ACCOUNT}/v1/user-bank-info/${uuid}`;
        return this.api.get(uri);
    }
};
SpeNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNAccountProxy = __decorate([
    Injectable()
], SpeNAccountProxy);

let UiPxDashboardModule = class UiPxDashboardModule {
};
UiPxDashboardModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [SpeNAccountProxy, ConfigService]
    })
], UiPxDashboardModule);

/*
 * Public API Surface of ui-px-dashboard
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ConfigService, SpeNAccountProxy, UiPxDashboardModule };
//# sourceMappingURL=wlp-ui-px-dashboard.js.map
